module.exports = __webpack_public_path__ + "fonts/google_logo.51144f04746482b2a48d971755013086.png?";


//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-signin-widget/dist/img/icons/login/google_logo.png
// module id = 117
// module chunks = 9